import type { ModelDefinition } from './types';

export const MODEL_CATALOG: readonly ModelDefinition[] = [
  { id: 'openai:gpt-5.6-sol', provider: 'openai', model: 'gpt-5.6-sol', displayName: 'GPT-5.6 Sol' },
  { id: 'openai:gpt-5.6-terra', provider: 'openai', model: 'gpt-5.6-terra', displayName: 'GPT-5.6 Terra' },
  { id: 'openai:gpt-5.6-luna', provider: 'openai', model: 'gpt-5.6-luna', displayName: 'GPT-5.6 Luna' },
  { id: 'siliconflow:meituan-longcat/LongCat-2.0', provider: 'siliconflow', model: 'meituan-longcat/LongCat-2.0', displayName: 'LongCat 2.0' },
  { id: 'siliconflow:zai-org/GLM-5.2', provider: 'siliconflow', model: 'zai-org/GLM-5.2', displayName: 'GLM-5.2' },
  { id: 'siliconflow:moonshotai/Kimi-K2.7-Code', provider: 'siliconflow', model: 'moonshotai/Kimi-K2.7-Code', displayName: 'Kimi K2.7 Code' },
  { id: 'siliconflow:deepseek-ai/DeepSeek-V4-Pro', provider: 'siliconflow', model: 'deepseek-ai/DeepSeek-V4-Pro', displayName: 'DeepSeek V4 Pro' },

];

export function findModel(id: string): ModelDefinition | undefined {
  return MODEL_CATALOG.find(model => model.id === id);
}
